import { createContext, useContext } from 'react';

export const LanguageContext = createContext({
  language: 'en',
  changeLanguage: () => {},
});

export const LanguageProvider = LanguageContext.Provider;

export const useLanguage = () => useContext(LanguageContext);
